import * as _ from 'underscore';
import { ListProperty } from './listProperty';
import { Align, SortState } from '../enums';
import { CSS } from '../const';
import { CommandOptions, ColumnOptions } from '../interfaces/options';
import { DataBindCommandOptions } from '../interfaces/options';
import { DefaultColumnOptions, DefaultCommandOptions } from '../const/defaultOptions';
import { IVectorListItem } from '../../MApp.Web.Client/models';

export class Column<T> extends ListProperty {
	private headerTemplate: string;
	private css: KnockoutComputed<string>;
	private cellCss: string;
	private autoWidth: boolean;
	private sortStateCss: KnockoutComputed<string>;
	private commands: CommandOptions[];
	private headerAlign: Align;
	private cellAlign: Align;
	private click: (item: T) => void;
	constructor(options?: ColumnOptions<T>) {
		options = $.extend(true, {}, DefaultColumnOptions, options || {});
		super(options);
		this.headerTemplate = options.headerTemplate;
		this.autoWidth = options.autoWidth;
		this.commands = options.commands ? options.commands.map(cmd => Column.CreateCommand(cmd)) : [];
		this.headerAlign = options.headerAlign;
		this.cellAlign = options.cellAlign;
		this.css = ko.computed(() => {
			return ''.concat(
				this.isSortable ? ' sortable-header ' : '',
				this.autoWidth ? ' column-autowidth ' : '',
				this.isSortActive() ? ' active ' : '',
				'align-',
				Align[this.headerAlign].toLowerCase()
			);
		});
		this.cellCss = this.customCss.concat(
			this.autoWidth ? ' column-autowidth ' : '',
			this.cellAlign ? 'align-'.concat(Align[this.cellAlign].toLowerCase()) : ''
		);
		this.sortStateCss = ko.pureComputed(() => {
			var currentState = this.sortState();
			switch (currentState) {
				case SortState.ASC:
					return 'mapp-studio-icons-angle-up';
				case SortState.DESC:
					return 'mapp-studio-icons-angle-down';
				case SortState.NONE:
				default:
					return '';
			}
		});
		this.click = (item: T) => {
			if (options.click) {
				options.click(item);
			}
		};
	}
	static CreateCommand(command: CommandOptions): DataBindCommandOptions {
		var dataBindCommand: DataBindCommandOptions = $.extend(
			true,
			{},
			DefaultCommandOptions,
			command || {}
		);
		var customFn = dataBindCommand.command;
		dataBindCommand.command = (...params: any[]) => {
			if (dataBindCommand.editable.apply(this, params)) {
				customFn.apply(this, params);
			}
		};
        var css: any = ko.isObservable(dataBindCommand.css) || typeof dataBindCommand.css === 'function'
            ? dataBindCommand.css          
            : ko.observable(dataBindCommand.css);
		dataBindCommand.cssFn = (item: any) => {
            var _css = typeof dataBindCommand.css === 'function' ? css(item) : css();           
			if (!dataBindCommand.editable.apply(this, [item])) {
				_css = _css.concat(' ', CSS.Disabled);
			}
			return _css;
        };      
        dataBindCommand.labelFn = (item: any) => {
            var label: any = typeof dataBindCommand.label === 'function' ? dataBindCommand.label : null;
            var _label = label !== null ? label(item) : dataBindCommand.label;
            return _label;
        };    
       return dataBindCommand;
	}
	public addCommand(command: CommandOptions) {
		this.commands.unshift(Column.CreateCommand(command));
	}
	public addDependency(
		visible?: (...params: any[]) => boolean,
		editable?: (...params: any[]) => boolean
	) {
		if (_.isFunction(visible)) {
			this.addVisibleDependency(visible);
		}
		if (_.isFunction(editable)) {
			this.addEditableDependency(editable);
		}
	}
	public addVisibleDependency(fn: (...params: any[]) => boolean) {
		this._addDependency(fn, 'visible');
	}
	public addEditableDependency(fn: (...params: any[]) => boolean) {
		this._addDependency(fn, 'editable');
	}
	private _addDependency(fn: (...params: any[]) => boolean, property: string) {
		for (var command of this.commands) {
			command[property] = fn;
		}
	}
}
